import React from 'react'
import styled, { css } from 'styled-components'
import { typographyElementsMap } from './typographyElementsMap'
import { useMediaQuery } from '@mote/helpers'

export const Text = ({
  tag = 'h1',
  children,
  styles = {},
  color = '#232323',
  alignment,
  style = {},
  ...rest
}) => {
  const mediaQuery = useMediaQuery([640, 992, 1200])
  if (!typographyElementsMap[tag]) {
    return (
      <div>
        Typography element not supported. Supported types are H1-6, p and small
      </div>
    )
  }

  const _style = { ...style, ...styles }

  return (
    <Root
      as={tag}
      alignment={alignment}
      color={color}
      style={_style}
      {...typographyElementsMap[tag].breakpoints[mediaQuery]}
      {...rest}
    >
      {children}
    </Root>
  )
}

const Root = styled.div`
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: ${({ fontWeight }) => fontWeight};
  line-height: ${({ lineHeight }) =>
    typeof lineHeight === 'string' && lineHeight.endsWith('%')
      ? lineHeight
      : `${lineHeight}px`};
  font-style: normal;
  color: ${({ color }) => color};
  margin: 0;

  ${({ alignment }) =>
    alignment &&
    css`
      text-align: ${alignment};
    `}
`

export const H1 = props => <Text tag='h1' {...props} />
export const H2 = props => <Text tag='h2' {...props} />
export const H3 = props => <Text tag='h3' {...props} />
export const H4 = props => <Text tag='h4' {...props} />
export const H5 = props => <Text tag='h5' {...props} />
export const H6 = props => <Text tag='h6' {...props} />
export const P = props => <Text tag='p' {...props} />
export const SMALL = props => <Text tag='small' {...props} />
